import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Components
import GLTransTableView from "./GLTransTableView"; //reused table component
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
//number format plugin
import numeral from "numeral";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";

import { PDFDownloadLink } from "@react-pdf/renderer";
import GLTransactionViewPdf from "../../components/PDF/GLTransactionViewPdf";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const ColorButton = withStyles(() => ({
	root: {
		color: "#fff",
		backgroundColor: "#4caf50",
		"&:hover": {
			backgroundColor: "#fff",
			color: "#4caf50",
		},
	},
}))(Button);

const GLTransactionView = () => {
	const { glid } = useParams();
	const classes = useStyles();
	const [glDetails, setGlDetails] = useState([]); //data to display in table
	const [items, setItems] = useState([]); //data to display in table

	// componentDidMount / document.ready ?
	useEffect(() => {
		getGLTransItems();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const getGLTransItems = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/get_single_gl_trans', {
			params:{
				glid: glid,  //branchIdNo
			}
		}).then((res)=>{
			setGlDetails(res.data.data)
			// console.log(res.data.data);
			setItems(res.data.data.items);
		}).catch((error)=>{
			console.log(error.message);
		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<NavLink to={"/account"}><h2 style={{color:"black"}}>Accounts</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/account/gl-transaction-history"}><h2 style={{color:"black"}}>GL Transaction History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>GL Transaction View #{glid}</h2>
			</div>
			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									GL Transaction View
								</div>
								<div className={classes.title}>
									GL Transaction View
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
						</Grid>
					</div>
					<CardContent>
					<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{glDetails.date || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Encoded By: 
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{glDetails.encoded_by || "Encoded By"}
								</Grid>
							</Grid>	
					</div>	
						{items ? (<GLTransTableView items={items}/>) : (<></>)}
					</CardContent>	
				</Card>
					<br/>					
					<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button>  */}
					{/* <Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{save_gl()}}>
						Save GL Transaction
					</Button> */}
					{
						items.length !== 0 ?
							<PDFDownloadLink 
								document={
									<GLTransactionViewPdf 
									data={{
										glid,
										gl_date: glDetails.date || "",
    								encoded_by: glDetails.encoded_by || "",
										items
									}}
									/>
								} 
								fileName={`GL-Transaction #${glid}.pdf`}
							>
								{({ loading }) => {
									return (
										loading ? 
										<ColorButton
											variant="contained"
											color="primary"
											classes={{
												root: classes.root,
												disabled: classes.disabled,
											}}
										>
											Loading...
										</ColorButton> : 
										<ColorButton
											variant="contained"
											color="primary"
											classes={{
												root: classes.root,
												disabled: classes.disabled,
											}}
										>
											Export PDF
										</ColorButton>
									);
								}}
							</PDFDownloadLink>
							: ""
					}
					</div>
				</div>
			</div>
	);
};

export default GLTransactionView;
